import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import {
	Section,
	SectionDescription,
	SectionTitle,
} from '@/features/app-shell/section'
import {
	SettingsMenu,
	SettingsMenuSkeleton,
} from '@/features/settings/components/menu'

import { Skeleton } from '@/components/ui/skeleton'

export const Route = createFileRoute('/_dashboard/settings')({
	beforeLoad: ({ location }) => {
		if (location.pathname === '/settings') {
			throw redirect({ to: '/settings/profile' })
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Settings | BitLyft AIR®',
			},
		],
	}),

	component: SettingsLayout,
	pendingComponent: SettingsRouteSkeleton,
	errorComponent: RouteErrorComponent,
})

function SettingsLayout() {
	return (
		<Section>
			<SectionTitle>Settings</SectionTitle>
			<SectionDescription>
				Configure notifications, manage members, and control tenant-level
				preferences for your BitLyft AIR® environment.
			</SectionDescription>

			<div className="my-6 mt-8 flex flex-col items-start justify-start gap-8 lg:flex-row">
				<SettingsMenu />

				<div className="flex w-full flex-col items-start justify-start gap-8">
					<Outlet />
				</div>
			</div>
		</Section>
	)
}

function SettingsRouteSkeleton() {
	return (
		<Section>
			<SectionTitle>Settings</SectionTitle>
			<SectionDescription>
				Configure notifications, manage members, and control tenant-level
				preferences for your BitLyft AIR® environment.
			</SectionDescription>

			<div className="my-6 mt-8 flex flex-col items-start justify-start gap-8 md:flex-row">
				<SettingsMenuSkeleton />

				<div className="flex w-full flex-col items-start justify-start gap-8">
					<Skeleton className="h-12 w-full" />
					<Skeleton className="h-12 w-full" />
				</div>
			</div>
		</Section>
	)
}
